import { baseServiceExportExcel } from './baseServiceExportExcel'
class ExportExcelAccountGuest extends baseServiceExportExcel {
  async export() {
    try {
      const res = await this.get('users/export/guest')
      if (!res?.ok) throw new Error('Kết nối API thất bại!')
      return res
    } catch (error) {
      console.error(error.message)
    }
  }
}

export const exportExcelAccountGuest = new ExportExcelAccountGuest()
